import { render, staticRenderFns } from "./imprint-en.vue?vue&type=template&id=4a28bf0a&scoped=true"
import script from "./imprint-en.vue?vue&type=script&lang=js"
export * from "./imprint-en.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a28bf0a",
  null
  
)

export default component.exports